import { Box, Text, useBreakpoint } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import React, { useEffect, useRef, useState } from "react";
import breakpoints from "../../theme/foundations/breakpoints";
import CompanyBox from "./CompanyBox";
import Separator from "./Separator";
import TimeLine from "./TimeLine";
import SmallerTimeLine from "./SmallerTimeLine";
import SmllerSeperator from "./SmllerSeperator";

const Card = ({
  companyTitle,
  companyDesc,
  start_date,
  end_date,
  role,
  direction,
}) => {
  const breakpoint = useBreakpoint({ ssr: false });
  const breakpointSize = breakpoints[breakpoint];
  const isSmallScreen = breakpointSize < "64em";

  const rotateInUpRight = keyframes`0%{
        opacity:0;
        transform:rotate3d(0,0,1,-90deg);
        transform-origin=right bottom;
    }
    100%{
        opacity:1;
        transform:rotate3d(0,0,0);
        transform-origin=right bottom;
    }
    `;
  const boxRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0 }
    );
    if (boxRef.current) {
      observer.observe(boxRef.current);
    }
    return () => {
      if (boxRef.current) {
        observer.unobserve(boxRef.current);
      }
    };
  }, []);

  if (!start_date) {
    return;
  }

  if (isSmallScreen) {
    return (
      <Box display="flex" h="auto" gap={4}>
        <SmllerSeperator />
        <Box w="96%" mb={4}>
          <SmallerTimeLine
            start_date={start_date}
            end_date={end_date}
            role={role}
          />
          <CompanyBox companyTitle={companyTitle} companyDesc={companyDesc} />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      ref={boxRef}
      display="flex"
      justifyContent="flex-start"
      alignItems="flex-start"
      h="450px"
      animation={isVisible && `${rotateInUpRight} 0.5s linear`}
      transition="all 0.5s linear"
      w="full"
      ml={14}
    >
      {direction === "forward" ? (
        <>
          <CompanyBox companyTitle={companyTitle} companyDesc={companyDesc} />
          <Separator />
          <TimeLine role={role} start_date={start_date} end_date={end_date} />
        </>
      ) : (
        <>
          <TimeLine role={role} start_date={start_date} end_date={end_date} />
          <Separator />
          <CompanyBox companyTitle={companyTitle} companyDesc={companyDesc} />
        </>
      )}
    </Box>
  );
};

export default Card;
